<template>
  <div class="container admin-table-page">
    <div class="param-title-wrap">
      <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
      </b-button>
      <h2 class="param-title">{{labels.title}}</h2>
    </div>
    <b-row v-if="!isLoading">
      <div class="admin-table-block mt-4" v-if="users?.length">
        <CorporateDataTable
          :items="usersTableItems"
          :fields="allFields"
          :filter-defs="tableFilterDefs"
          :labels="tableLabels"
          :default-per-page="10"
          :page-options="[10, 20, 50, 100]"
          :narrow="false"
          :table-min-height="500"
          :table-max-height="500"
        >
          <template #toolbar-actions>
            <b-button size="sm" class="table-toolbar-add-btn" @click="goToCreateUser()">
              {{ labels.create }}
            </b-button>
          </template>
          <template #cell(nombre)="data">
            <div class="text-left">{{ data.item?.nombre }}</div>
          </template>
          <template #cell(id_rol_nombre)="data">
            <div class="text-left">{{ data.item?.id_rol_nombre }}</div> 
          </template>
          <template #cell(acciones)="data">
            <b-button
              style="background-color: #FF924C; width: 30px; height: 30px;"
              class="md-fab md-primary user-edit-action-btn"
              @click.stop="editUser(data.item)" 
            >
              <i><font-awesome-icon :icon="['fas', 'pencil-alt']" size="xs"/></i>
            </b-button>
          </template>
          <template #cell(accionInac)="data">
            <b-button v-if="data.item?.state == 1"
              variant="link"
              class="p-0 border-0 shadow-none"
              @click="inactivaUser(data.item)"
            >
              <i><font-awesome-icon :icon="['fas', 'toggle-on']" size="xl"/></i>
            </b-button>
            <b-button v-else
              variant="link"
              class="p-0 border-0 shadow-none"
              @click="activarUser(data.item.id)"
            >
              <i><font-awesome-icon :icon="['fas', 'toggle-off']" size="xl"/></i>              
            </b-button>
          </template>
        </CorporateDataTable>
      </div>
      <div class="admin-table-block mt-4" v-else>
        <h5>{{ labels.empty }}</h5>
      </div>
    </b-row>
    <b-row v-else>
      <b-col md="12" lg="12" class="p-4 mx-auto">
        <div class="text-center">
          <b-spinner></b-spinner>
        </div>
      </b-col>
    </b-row>
    
    <!-- Modales -->
    <InfoUser :modInfoUser="showInfoUser" :dataRole="roles" :dataUser="inforUser" @cierraModal="cierraModal"/>
    <CreateUser :showDialogCreate="showDialogCreate" @closeModal="cierraModal" @created="cargaUsuarios"/>
    <EditarUser 
      :showDialogEdit="showDialogEdit" 
      :formEdit="formEdit" 
      @cierraModal="cierraModal"
      @updated="actualizarUsuarioEnLista"
    />
    <InacticaItem 
      :InactivaItem="showInactivateModal" 
      @confirmDelete="confirmInactivate" 
      @cierraModal="cierraModal"
    />
  </div>
</template>

<script>
import User from "@/services/User";
import Rol from "@/services/Roles";
import CorporateDataTable from "../utils/CorporateDataTable.vue";
import InfoUser from "./InfoUser.vue"; 
import CreateUser from "./Create.vue";
import EditarUser from "./EditarUser.vue"; 
import InacticaItem from "../utils/InacticaItem.vue"; 

export default {
  name: "ListUsers",
  components: {
    InfoUser,
    CreateUser,
    EditarUser,
    InacticaItem,
    CorporateDataTable
  },
  data: () => ({
    rolSeleccionado: {},
    myOptions: [],
    nameUser: '',
    identificacionUser: '',
    telefonoUser: '',
    correo: '',
    rolSelected: '',
    currentSort: "createdAt",
    currentSortOrder: "asc",
    showDialog: false,
    showDialogEdit: false,
    dialogItem: {},
    users: [],
    roles: [],
    searched: [],
    search: null,
    isEmpty: false,
    isUpdating: false,
    isLoading: false,
    success: false,
    error: false,
    elementosPorPagina: 10,
    datosPaginados: [],
    paginaActual: 1,
    searchUser: null,
    searchEmail: null,
    showInfoUser: false,
    showDialogCreate: false,
    showInactivateModal: false,
    userToInactivate: null,
    inforUser: [],
    formEdit: {
      nameUser: '',
      cedula: '',
      identificacionUser: '',
      phone: '',
      telefonoUser: '',
      correo: '',
      idUser: '',
      id_rol: '',
      password: ''
    },
  }),
  computed: {
    labels() {
      if (this.$store.state._language == "es-ES") { 
        return {
          title: "Usuarios",
          subtitle: "Instrucciones",
          instructive: ["Bienvenid@ a la plataforma para la visualización y creación de usuarios"],
          search: "Buscar por Nombre de Usuario",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Fecha Creación",
          name: "Nombre",
          email: "Correo Electrónico",
          informationUser: "Información",
          edit: "Editar",
          inactivate: "Inactivar",
          companyId: "Id de la Compañia",
          phonenumber: "Teléfono de contacto",
          idNumber: "Número de identificación",
          role: "Rol",
          empty: "Aún no cuentas con usuarios",
          create: "Añadir usuario",
          active: "Activo",
          inactive: "Inactivo",
          status: "Estado",
          notFoundMessage: "No hay datos con",
          identificationCard: "Cedula",
          phone: "Telefono",
          passw: "Password"
        }
      } else {
        return {
          title: "Users",
          subtitle: "Instructions",
          instructive: ["Welcome to the platform for the visualization and creation of users."], 
          search: "Search by User Name",
          information: "Información del Usuario",
          tapLabel: "Datos",
          createdAt: "Created Date",
          name: "User Name",
          email: "Email",
          informationUser: "Information",
          edit: "Edit",
          inactivate: "Inactivate",
          companyId: "Company Id",
          phonenumber: "Contact Number",
          idNumber: "Identification Id",
          role: "Role",
          empty: "You don't have users yet",
          create: "Add user",
          active: "Activo",
          inactive: "Inactive",
          status: "Status",
          notFoundMessage: "There is no data with",
          identificationCard: "Identification Card",
          phone: "Phone",
          passw: "Password"
        }
      }
    },
    usersTableItems() {
      return (this.users || []).map((item) => ({
        ...item,
        nombre: item?.nombre || item?.name || item?.fullName || '',
        id_rol_nombre: this.nombreRol(item?.id_rol),
      }));
    },
    allFields() {
      return [
        { key: 'nombre', label: this.labels.name, sortable: true, thClass: 'text-left', tdClass: 'text-left align-middle' },
        { key: 'email', label: this.labels.email, sortable: true },
        { key: 'id_rol_nombre', label: this.labels.role, sortable: true },
        { key: 'acciones', label: this.labels.edit, thClass: 'text-center', tdClass: 'text-center align-middle', sortable: false },
        { key: 'accionInac', label: this.labels.status, thClass: 'text-center', tdClass: 'text-center', sortable: false }
      ];
    },
    tableFilterDefs() {
      return [
        { key: 'nombre', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar nombre...' : 'Filter name...' },
        { key: 'email', type: 'text', placeholder: this.$store.state._language == "es-ES" ? 'Filtrar correo...' : 'Filter email...' }
      ];
    },
    tableLabels() {
      return {
        noRow: this.labels.empty,
        noMatches: this.$store.state._language == "es-ES" ? "No se encontraron resultados" : "No results found",
        searchPlaceholder: this.$store.state._language == "es-ES" ? "Buscar en la tabla..." : "Search in table...",
        rowsPerPage: this.$store.state._language == "es-ES" ? "Filas por página:" : "Rows per page:",
        noSort: this.$store.state._language == "es-ES" ? "Sin orden" : "No sorting",
        sortAsc: this.$store.state._language == "es-ES" ? "A-Z / Menor a mayor" : "A-Z / Low to high",
        sortDesc: this.$store.state._language == "es-ES" ? "Z-A / Mayor a menor" : "Z-A / High to low",
        columns: this.$store.state._language == "es-ES" ? "Columnas" : "Columns",
        showAllColumns: this.$store.state._language == "es-ES" ? "Mostrar todas" : "Show all",
        filters: this.$store.state._language == "es-ES" ? "Filtros" : "Filters",
        clearFilters: this.$store.state._language == "es-ES" ? "Limpiar filtros" : "Clear filters",
      };
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    cierraModal(val) {
      this.showInfoUser = val 
      this.showDialogCreate = val
      this.showDialogEdit = val 
      this.showInactivateModal = val 
    },
    goToCreateUser() {
      this.showDialogCreate = true
    },
    actualizarUsuarioEnLista(datosActualizados) {
      this.users = this.users.map((user) => {
        if ((user.id || user.idUser || user._id) === datosActualizados.id) {
          return {
            ...user,
            nombre: datosActualizados.nombre,
            email: datosActualizados.email,
            cedula: datosActualizados.cedula,
            telefono: datosActualizados.telefono,
            id_rol: datosActualizados.id_rol
          }
        }
        return user
      })
    },
    cargaUsuarios() {
      this.isLoading = true;
      User.getAllUsers(this.$store.state.userName)
        .then((result) => {
          this.users = result.data.users;
          this.isEmpty = this.users.length == 0;
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showInfo(id) {
      User.getAllUsersById(id) 
        .then((res) => { 
          this.inforUser = res.data.exiteUser 
          this.showInfoUser = true 
        })
        .catch((err) => { 
          console.log(err) 
        })
    },
    editUser(user) {
      if (!user) return;

      const userId = user.id || user.idUser || user._id;
      if (!userId) return;

      User.getAllUsersById(userId)
        .then((res) => {
          const sourceUser = Array.isArray(res?.data?.exiteUser)
            ? res.data.exiteUser[0]
            : (res?.data?.exiteUser || user);
          const roleId = user?.id_rol ?? sourceUser?.id_rol ?? sourceUser?.rol?.id ?? sourceUser?.role?.id ?? sourceUser?.idRol ?? sourceUser?.rolId ?? "";

          this.dialogItem = { ...sourceUser };
          this.formEdit.nameUser = sourceUser?.nombre || sourceUser?.name || sourceUser?.fullName || "";
          this.formEdit.cedula = sourceUser?.cedula || "";
          this.formEdit.correo = sourceUser?.email || sourceUser?.correo || "";
          this.formEdit.phone = sourceUser?.telefono || sourceUser?.phone || "";
          this.formEdit.id_rol = roleId === "" || roleId === null || roleId === undefined ? "" : String(roleId);
          this.formEdit.idUser = sourceUser?.id || userId;
          this.showDialogEdit = true;
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("No se pudo cargar el usuario para editar");
        });
    },
    inactivaUser(user) {
      this.userToInactivate = user;
      this.showInactivateModal = true;
    },
    confirmInactivate() {
      if (!this.userToInactivate) return;

      const userId = this.userToInactivate.id || this.userToInactivate.idUser || this.userToInactivate._id;
      if (!userId) return;

      this.isLoading = true;

      User.inactivarUser(userId)
        .then((res) => {
          this.$toast.success(res.data.message || "Usuario inactivado correctamente");
          
          const index = this.users.findIndex(u => (u.id || u.idUser || u._id) === userId);
          if (index !== -1) {
            this.users[index].state = 0;
          }
          
          this.showInactivateModal = false;
          this.userToInactivate = null;
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("No se pudo inactivar el usuario");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    activarUser(id) {
      User.activarUser(id) 
        .then((res) => { 
          this.$toast.success(res.data.message || "Usuario activado correctamente"); 
          
          const index = this.users.findIndex(u => u.id === id); 
          if (index !== -1) {
            this.users[index].state = 1; 
          }
        })
        .catch((err) => { 
          console.error(err); 
          this.$toast.error("No se pudo activar el usuario"); 
        });
    },
    deleteUser(id) {
      this.isLoading = true; 
      User.deleteUser(id)
        .then(() => { 
          this.isLoading = false; 
          this.users = this.users.filter(user => user.id != id); 
        })
        .catch(() => {
          this.isLoading = false;
          this.$toast.error("No se pudo eliminar el usuario");
        });
    },
    nombreRol(numRol) {
      const rol = this.roles.find(r => r.id == numRol); 
      return rol ? rol?.nombre : ''; 
    }
  },
  mounted() {
    this.cargaUsuarios();
    Rol.getAllRoles() 
      .then((rta) => { 
        this.roles = rta.data.roles; 
      })
      .catch(() => { 
        this.error = true; 
      })
  },
};
</script>

<style src="../main.css"> 
</style>